<template>
</template>

<script>
import router from '../router'
import NavigationBar from '../components/navigation-bar/NavigationBar'

export default {
    name: 'Accounts',
    components: {
        NavigationBar
    },

    created() {
        router.replace('/settings/accounts')
    }
}
</script>

<style>

</style>